import { OutboundReferenceCollection } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { sumBy } from 'lodash-es';
import { useEffect } from 'react';

import { formatNumber } from 'src/utils/common';

import useSWRProductOutboundTxns from 'src/hooks/swr/useSWRProductOutboundTxnsForInventory';

interface AgCellInventoryDepletionDateProps extends ICellRendererParams {
  inventoryId: string;
  quantity: number;
}

const AgCellInventoryDepletionDate = (params: AgCellInventoryDepletionDateProps) => {
  const inventoryId = params.inventoryId;
  const quantity = params.quantity;
  const isInfinite = !isFinite(quantity);
  const { productOutboundTransactions } = useSWRProductOutboundTxns(isInfinite ? undefined : inventoryId);
  const orderOutboundTxns = productOutboundTransactions?.filter(
    (txn) => txn.referenceCollection === OutboundReferenceCollection.ORDER,
  );

  // 예상 발주는 고객들의 주문량이 중요하기 때문에 순수한 주문 소진량만 포함한다.
  const outboundSum = sumBy(orderOutboundTxns, 'requestQuantity');
  const estimatedQuantity = outboundSum !== 0 ? quantity / (outboundSum / 30) : 0;
  const value = isInfinite ? 0 : orderOutboundTxns?.length === 0 ? 0 : estimatedQuantity;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  if (isInfinite) return <span className='gray600'>-</span>;

  return orderOutboundTxns?.length === 0 ? (
    <span className='gray600'>-</span>
  ) : (
    <span>
      {formatNumber(estimatedQuantity, 1)}
      <span className='gray600'>({outboundSum})</span>
    </span>
  );
};

export default AgCellInventoryDepletionDate;
